export const GET_PROVIDERS = "GET_PROVIDERS";
export const SET_SCHEDULE_SLOTS = "SET_SCHEDULE_SLOTS";
export const SET_SCHEDULE_TELEMED = "SET_SCHEDULE_TELEMED";
export const SET_TICKET_STATUS = "SET_TICKET_STATUS";
export const SET_CHANGE_PROVIDER_STATUS = "SET_CHANGE_PROVIDER_STATUS";
export const SET_CASE_HISTORY = "SET_CASE_HISTORY";
